import { Children, cloneElement, isValidElement } from 'react'
import { useFeatureOff } from '../hooks/useEnvironment'

// Wraps one control for a feature that may be off on staging (shared/staging-features.js).
// Off: the control is disabled and a short note says why. On: renders the control as is.
export default function OffOnStaging({ feature, children }) {
  const reason = useFeatureOff(feature)
  if (!reason) return children
  return (
    <span className="off-on-staging" data-off-feature={feature}>
      {Children.map(children, (c) => (isValidElement(c) ? cloneElement(c, { disabled: true, title: reason }) : c))}
      <span className="badge badge-neutral off-on-staging-note">Off on staging: {reason}</span>
    </span>
  )
}
